import * as React from 'react'
import { Fragment, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Loader from '../Loader/Loader';
import LoginButtons from "../LoginButtons/LoginButtons";

import { useHookStore } from '../../hook-store/store';
import { ollamaMcpTranslate } from '../../utils/ollama/ollama-util';

import {
  ollamaNodeJsUrl,
 } from '../../lib/api';

import { marks } from '../../utils/marks';
// import { marks } from '~utils/marks'
import classes from './PromptTranslate.module.css';



const PromptTranslate = (props) => {
  const {
  } = props;

  const [t] = useTranslation('translation')

  const [store, dispatch] = useHookStore();
  const { isAuth } = store.uiStore;

  const [textInput, setTextInput] = useState('');
  const [resultText, setResultText] = useState('');
  const [showTranslate, setShowTranslate] = useState(false);
  const [showCopyResult, setShowCopyResult] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const setTextInputHandler = (event) => {

    setTextInput(event.target.value);
  };

  const showCopyResultHandler = (resultText) => {
    navigator.clipboard.writeText(resultText);

    setShowCopyResult(true);

    setTimeout(() => {
      setShowCopyResult(false);
    }, 3000);
  };

  const textTranslateHandler = async (textInput) => {
    try {
      setIsLoading(true);

      const resData = await ollamaMcpTranslate(
        ollamaNodeJsUrl,
        localStorage.getItem('token'),
        textInput,
      )

      if (resData.data?.result?.content) {
        setResultText(resData.data.result.content);
      }
      setIsLoading(false);

      return resData;

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      throw err;
    }
  };


  let promptTranslateBody;

  promptTranslateBody = (
    <div>
      <div>
        <span
          onClick={() => {
            setShowTranslate(!showTranslate);
          }}
        >
          {t('promptTranslate01', 'translate text into English')} {marks.triangleDown} {marks.questionCircleMark}
        </span>
      </div>
      {showTranslate && (
        <div className={classes.promptTranslate}
        // style={{border: "1px solid red"}}
        >
          <div className={classes.promptTranslateRow}>
            <p>
              {t('promptTranslate02', 'User can translate text into English for text prompt input.')}
            </p>
            <p>
              {t('promptTranslate03', 'Because of the limitation of this translation system, result may be inaccurate or have some additional information.')}
            </p>
            <p>
              {t('promptTranslate04', 'Text should be less than 100 characters.')}
            </p>
          </div>
          <div className={classes.promptTranslateRow}>
            <input className='inputBase'
              type="text"
              placeholder={`${t('promptTranslate09', 'enter text in your language.')}`}
              onChange={(event) => {
                setTextInputHandler(event);
              }}
            />
          </div>
          {textInput && (
            <div className={classes.promptTranslateRow}>
              {textInput} ({textInput.length})
            </div>
          )}
          {!isAuth && (
            <div>
              <div className={classes.promptTranslateRow}>
                {t('promptTranslate10', 'Login is required')}
              </div>
              <LoginButtons 
                hideSignup={false}
              />
            </div>
          )}
          {isAuth && (
            <div className={classes.promptTranslateRow}>
              <button className='btnBase'
                style={{border: '0.1px solid gray'}}
                disabled={isLoading || textInput.length === 0 || textInput.length > 100}
                onClick={() => {
                  textTranslateHandler(textInput);
                }}
              >
                {t('promptTranslate05', 'Translate to English')}
              </button>
              {isLoading && (
                <Loader />
              )}
            </div>
          )}
          {resultText && (
            <div className={classes.promptTranslateRow}>
              <div>
                {t('promptTranslate06', 'Translation result')}:
              </div>
              <div>
                <span>{resultText}</span>
                <span
                  onClick={() => {
                    showCopyResultHandler(resultText);
                  }}
                >
                {' '}{marks.cloneMark}
              </span>
              {showCopyResult && (
                <span> ({t('promptTranslate07', 'copied')})</span>
              )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
  return (
    <Fragment>
      <div>
        {promptTranslateBody}
      </div>
    </Fragment>
  );
}

export default PromptTranslate;
